var _defs, _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcInstagramColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43.68 43.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 11.19,
    cy: 37.53,
    fx: -16.20244276818246,
    r: 88.8,
    gradientTransform: "matrix(0.65, -0.76, 0.61, 0.53, -22.92, 22.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ed32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f8d939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f5a54d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f0536c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ee2a7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#9e2aa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#5b2acd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#2a2ae8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#0b2af9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002aff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 43.68,
    height: 43.68,
    rx: 7.46
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.52,42.49H18.61a11.21,11.21,0,0,1-11.2-11.2V19a11.21,11.21,0,0,1,11.2-11.2H32.52A11.21,11.21,0,0,1,43.71,19V31.29A11.21,11.21,0,0,1,32.52,42.49ZM18.61,10.32A8.72,8.72,0,0,0,9.9,19V31.29A8.72,8.72,0,0,0,18.61,40H32.52a8.72,8.72,0,0,0,8.71-8.71V19a8.72,8.72,0,0,0-8.71-8.71Z",
    transform: "translate(-3.72 -3.32)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.56,35.13a10,10,0,1,1,10-10A10,10,0,0,1,25.56,35.13Zm0-17.45A7.48,7.48,0,1,0,33,25.16,7.49,7.49,0,0,0,25.56,17.68Z",
    transform: "translate(-3.72 -3.32)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.44,15.5a2.07,2.07,0,1,1-2.06-2.07A2.07,2.07,0,0,1,37.44,15.5Z",
    transform: "translate(-3.72 -3.32)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagramColored);
export default __webpack_public_path__ + "static/media/ic_instagram_colored.3df5873df8e4a8ca8bdac79ef00e5bf4.svg";
export { ForwardRef as ReactComponent };